<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เข้างานเรียบร้อยแล้ว</v-alert>
    </v-slide-x-reverse-transition>
    <h2>วันที่ {{ date }} น.</h2>
    <v-card>
        <div class="mb-2">
            <v-tabs grow>
                <v-tab @click="page(title_detail.shifts_id)" v-for="(title_detail,index) in title_list" :key="index">{{ title_detail.shift_name }}</v-tab>
            </v-tabs>
            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_page === false">
                <div v-for="(detail_shift,index_shift) in data" :key="index_shift">
                    <div class="grid_in_time_work_list justify-space-between pa-3" v-if="title_type_timework == detail_shift.shifts_id">
                        <div v-for="(detail_employee,index_employee) in detail_shift.employee" :key="index_employee">
                            <v-card class="pa-3 text-center" color="#eee" v-if="detail_employee.status_start_work == true">
                                <div>{{ detail_employee.employee_name }}</div>
                                <div>เวลาเข้างาน {{ detail_employee.start_work }} น.</div>
                                <div class="success--text">เข้างานเรียบร้อยแล้ว</div>
                            </v-card>
                            <v-card class="pa-3 text-center" v-if="detail_employee.status_start_work == false" @click="openStartWork(detail_shift.shift_name,detail_employee.work_time_id,detail_employee.employee_name)">
                                <div>{{ detail_employee.employee_name }}</div>
                                <div>เวลาเข้างาน {{ detail_employee.start_work }} น.</div>
                                <div class="error--text">ยังไม่เข้างาน</div>
                            </v-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-card>
    <v-dialog v-model="open_start_work" persistent max-width="600">
        <v-card>
            <v-card-title>
                {{ shift_name }}
            </v-card-title>

            <v-card-text>
                {{ employee_name }} เข้างานใช่หรือไม่ ?
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" @click="startWork()">
                    ตกลง
                </v-btn>
                <v-btn color="error" @click="open_start_work = false">
                    ยกเลิก
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import intimework from '@/api/team/teaminouttimework/intimework.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_add: false,
            open_start_work: false,
            interval: null,
            date: Intl.DateTimeFormat('th-TH', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            }).format(),
            shift_name: null,
            work_time_id: null,
            employee_name: null,
            title_type_timework: null,
            title_list: [],
            data: [],
        }
    },
    methods: {
        async startInTimeWorkList() {
            await this.createInTimeWork()
            await this.inTimeWorkList()
        },
        async createInTimeWork() {
            intimework.createInTimeWork().catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async inTimeWorkList() {
            this.loading_page = true
            this.title_list = []
            this.data = []
            intimework.inTimeWorkList().then((response) => {
                if (response.data.successful === true) {
                    response.data.workShifts.forEach((detail, index) => {
                        if (index == 0 && this.title_type_timework == null) {
                            this.title_type_timework = detail.shifts_id
                        }
                        this.title_list.push({
                            shifts_id: detail.shifts_id,
                            shift_name: detail.shift_name,
                        })
                    })

                    this.data = response.data.workShifts
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async page(type) {
            this.title_type_timework = type
        },
        async openStartWork(shift_name, work_time_id, employee_name) {
            this.shift_name = shift_name
            this.work_time_id = work_time_id
            this.employee_name = employee_name
            this.open_start_work = true

        },
        async startWork() {
            this.loading_page = true
            this.open_start_work = false
            const data = {
                start_date: Intl.DateTimeFormat('th-TH', {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                }).format()
            }
            intimework.startWork(this.work_time_id, data).then((response) => {
                if (response.data.successful === true) {
                    this.inTimeWorkList()
                    this.shift_name = null
                    this.work_time_id = null
                    this.employee_name = null
                    this.alert_show_add = true
                    setTimeout(() => this.alert_show_add = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    mounted() {
        this.startInTimeWorkList()
        this.interval = setInterval(() => {
            this.date = Intl.DateTimeFormat('th-TH', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            }).format()
        }, 1000)
    }
}
</script>

<style scoped>
.grid_in_time_work_list {
    display: grid;
    grid-template-columns: 30% 30% 30%;
    grid-row-gap: 10px;
}

.cursor_in_time_work_list {
    cursor: pointer;
}
</style>
